import { Close } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import { COLORS } from "../../../ui/Theme";
import { useRoiPersonalWatchContext } from "../../../context/roi/personal-watch/RoiPersonalWatchContext";
import { deleteData } from "../../../lib/dashboard/actions";
import { mutate } from "swr";
import Loading from "../../../components/loader/Loading";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  outline: "none",
};

const RoiDeletePersonalWatch = () => {
  const {
    isDeleteModal,
    setIsDeleteModal,
    selectedWatch,
    isValidatingWatches,
  } = useRoiPersonalWatchContext();

  const handleDelete = async () => {
    const res = await deleteData(
      `/favorite/favorite-roi-groups/${selectedWatch.id}`
    );
    if (res.status === 200) {
      await mutate("/favorite/favorite-roi-groups");
      setIsDeleteModal(false);
    }
  };

  return (
    <Modal open={isDeleteModal} onClose={() => setIsDeleteModal(false)}>
      <Card sx={style}>
        <CardContent
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
            gap: "15px",
          }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
            آیا مطمئن هستید؟
          </Typography>
          <Typography sx={{ fontSize: "14px" }}>
            در صورت پاک کردن دیده‌بان دیگر قابل بازگشت نمی باشد
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "15px",
            }}
          >
            <button
              disabled={isValidatingWatches}
              onClick={handleDelete}
              className={"btn btn-red"}
              style={{ justifyContent: "center" }}
            >
              {isValidatingWatches ? (
                <Loading color={COLORS.SOFTRED} size={"8px"} />
              ) : (
                "حذف دیده‌بان"
              )}
            </button>
            <button
              onClick={() => setIsDeleteModal(false)}
              className="btn btn-softblue"
              style={{ justifyContent: "center" }}
            >
              بازگشت
            </button>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default RoiDeletePersonalWatch;
